import { User } from '@yarmill/types';
import { axios } from '@yarmill/utils';
import { AxiosPromise } from 'axios';

export function getDeactivatedUsers(): AxiosPromise<User[]> {
  return axios.get('api/user/disabled');
}
